import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import ChatPage from './pages/ChatPage';
import AboutPage from './pages/AboutPage';
import EnterprisePage from './pages/EnterprisePage';
import PersonalVisaPage from './pages/PersonalVisaPage';
import KnowledgeBasePage from './pages/KnowledgeBasePage';
import { AdminProtectedRoute } from './components/AdminProtectedRoute';
import { LanguageProvider } from './i18n/LanguageContext';

function App() {
  return (
    <LanguageProvider>
      <Router>
        <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-purple-50 dark:from-gray-900 dark:via-gray-800 dark:to-gray-900">
          <Routes>
            <Route path="/" element={<ChatPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/enterprise" element={<EnterprisePage />} />
            <Route path="/personal-visa" element={<PersonalVisaPage />} />
            <Route path="/chat" element={<Navigate to="/" replace />} />
            <Route
              path="/knowledge-base"
              element={
                <AdminProtectedRoute>
                  <KnowledgeBasePage />
                </AdminProtectedRoute>
              }
            />
          </Routes>
        </div>
      </Router>
    </LanguageProvider>
  );
}

export default App;
